import { useEffect, type FC } from "react";
import { useLocation } from "react-router-dom";

/** Garante que toda troca de rota comece no topo (evita herdar scroll da lista de terapeutas). */
export function scrollWindowToTop() {
  if (typeof window === "undefined") return;
  try {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  } catch {
    /* ignore */
  }
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

const ScrollToTop: FC = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // Âncoras (#faq, #grupo-avisos) devem manter o destino do hash.
    if (hash) return;
    scrollWindowToTop();
    const t = window.setTimeout(scrollWindowToTop, 0);
    return () => window.clearTimeout(t);
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
